'use client';

const steps = [
  {
    title: '예약하고,',
    description:
      '물품, 주소, 일정을 순서대로 입력합니다. 투명하게 산출된 가격을 확인 후 결제하시면 예약이 완료됩니다.',
    benefits: [
      '전화 통화도, 흥정도 필요 없습니다.',
      '투명하고 합리적인 가격을 결제 전에 먼저 확인할 수 있습니다.',
      '엘리베이터 없어도 최소 비용 추가로 부담 없이 신청 가능합니다.',
      '지정시간 배송, 집안 배송, 분해·설치 등 필요한 옵션을 선택할 수 있습니다.',
    ],
    featured: true,
  },
  {
    title: '문 앞에 두고,',
    description:
      '정확한 수거·배송 시간은 전날 저녁(당일 예약은 예약 직후)에 문자로 안내됩니다. 미리 물품만 문 앞에 내놓으면 끝입니다.',
    benefits: [
      '포장도, 편의점 방문도 필요 없습니다.',
      '대면 인수인계나 운반도움도 필요 없습니다.',
      '마냥 집에서 기다릴 필요도 없습니다.',
    ],
    featured: false,
  },
  {
    title: '확인하면, 끝!',
    description:
      '도착 전 안내, 수거 전 영상, 배송 완료 영상을 실시간 문자로 받아보실 수 있습니다.',
    benefits: [
      '배송 오류나 물품 파손을 걱정할 필요 없습니다.',
      '배송 전 과정을 문자로 확인할 수 있습니다.',
      '배송 전후 상태를 영상으로 비교 확인할 수 있습니다.',
    ],
    featured: false,
  },
];

export default function HowItWorks() {
  return (
    <section className="relative bg-white overflow-hidden py-20 sm:py-32">
      <div
        className="absolute inset-x-0 bottom-0 h-1/3 pointer-events-none"
        style={{ background: 'linear-gradient(to top, #496d8b, transparent)' }}
      />
      <div
        className="absolute inset-0 bg-cover bg-center opacity-20 pointer-events-none"
        style={{ backgroundImage: "url('/images/map_south02.png')" }}
      />
      <div className="relative mx-auto px-4" style={{ maxWidth: 1080 }}>
        {/* Header */}
        <div className="text-center" style={{ marginBottom: 64 }}>
          {/* <span
            className="block font-bold uppercase"
            style={{
              fontSize: '0.72rem',
              letterSpacing: '0.18em',
              color: '#e8793c',
              marginBottom: 8,
            }}
          >
            How to use
          </span> */}
          <h2
            className="text-xl sm:text-2xl font-bold mb-4 leading-snug"
            style={{ color: '#EBC247' }}
          >
            당나귀 배송은 어떻게 이용하나요?
          </h2>
        </div>

        {/* Card Grid */}
        <div className="relative grid grid-cols-1 gap-6" style={{ maxWidth: 1080 }}>
          {/* Arrows - desktop only */}
          <div className="hidden sm:block">
            <span
              className="absolute z-10 text-[#c8d6e5] text-2xl select-none"
              style={{ top: 28, left: 'calc(33.33% - 14px)' }}
            >
              →
            </span>
            <span
              className="absolute z-10 text-[#c8d6e5] text-2xl select-none"
              style={{ top: 28, left: 'calc(66.66% - 14px)' }}
            >
              →
            </span>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {steps.map((step) => (
              <StepCard key={step.title} {...step} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function StepCard({
  title,
  description,
  benefits,
  featured,
}: {
  title: string;
  description: string;
  benefits: string[];
  featured: boolean;
}) {
  return (
    <div
      className="transition-all duration-300"
      style={{
        background: featured ? '#1a3a5c' : '#f7f9fc',
        border: featured ? '1.5px solid #1a3a5c' : '1.5px solid #e4eaf3',
        borderRadius: 20,
        padding: '36px 28px 32px',
        cursor: 'default',
      }}
      onMouseEnter={(e) => {
        const el = e.currentTarget;
        el.style.transform = 'translateY(-4px)';
        if (featured) {
          el.style.borderColor = '#e8793c';
          el.style.boxShadow = '0 16px 48px rgba(26,58,92,.35)';
        } else {
          el.style.borderColor = '#c2d4e8';
          el.style.boxShadow = '0 12px 40px rgba(26,58,92,.12)';
        }
      }}
      onMouseLeave={(e) => {
        const el = e.currentTarget;
        el.style.transform = '';
        el.style.borderColor = featured ? '#1a3a5c' : '#e4eaf3';
        el.style.boxShadow = '';
      }}
    >
      <h3
        className="font-black"
        style={{
          fontSize: 'clamp(1.5rem, 2.5vw, 1.9rem)',
          color: featured ? '#ffffff' : '#1a3a5c',
          marginBottom: 16,
        }}
      >
        {title}
      </h3>

      <p
        style={{
          fontSize: '0.88rem',
          color: featured ? '#a8c0d8' : '#4a6484',
          lineHeight: 1.75,
          marginBottom: 24,
        }}
      >
        {description}
      </p>

      <div
        style={{
          height: 1,
          background: featured
            ? 'linear-gradient(90deg, #2d5580, transparent)'
            : 'linear-gradient(90deg, #e4eaf3, transparent)',
          marginBottom: 20,
        }}
      />

      <ul className="flex flex-col" style={{ gap: 10 }}>
        {benefits.map((b) => (
          <li key={b} className="flex items-start" style={{ gap: 10 }}>
            <span
              className="flex-shrink-0 flex items-center justify-center font-extrabold"
              style={{
                width: 20,
                height: 20,
                borderRadius: 6,
                background: featured ? 'rgba(46,158,91,.2)' : '#e8f3e8',
                color: featured ? '#5dd48a' : '#2e9e5b',
                fontSize: '0.72rem',
              }}
            >
              +
            </span>
            <span
              style={{
                fontSize: '0.83rem',
                color: featured ? '#c8dcee' : '#3a5878',
                lineHeight: 1.6,
              }}
            >
              {b}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
